<template>

  <div>
    <el-row>
       <el-col :span="24">
         <br />
          <tickets-table :site-id="rowData.id" :read-only="readOnly" :hide-site="true" :show-owner="true" />
       </el-col>
    </el-row>

  </div>

</template>


<script>

import TicketsTable from '@/components/tables/TicketsTable'

export default {

  components: {
    TicketsTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    },
    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  data () {
    return {
      telcoId: this.isTelco() ? Number(this.org().id) : this.owner
    }
  }   // data
}

</script>



// WEBPACK FOOTER //
// SiteMaint.vue?15773b80